import { between, todayStart } from "./dateUtils";

export const filterAndSortEventos = ({
    eventos,
    query,
    dateFrom,
    dateTo,
    estado,
    sortBy,
}) => {
    const today = todayStart();
    const q = String(query || "").trim().toLowerCase();

    const out = (Array.isArray(eventos) ? eventos : [])
        .filter((ev) => {
            // texto
            const matchesText =
                !q ||
                [ev?.nombre, ev?.descripcion]
                    .filter(Boolean)
                    .some((t) => String(t).toLowerCase().includes(q)) ||
                (ev?.menus || []).some((m) => String(m?.nombre || "").toLowerCase().includes(q));

            // fechas
            const okDate =
                (!dateFrom && !dateTo) ||
                between(ev?.fechaInicio, dateFrom, dateTo) ||
                between(ev?.fechaFin, dateFrom, dateTo);

            // estado temporal
            let okEstado = true;
            const start = ev?.fechaInicio ? new Date(ev.fechaInicio).setHours(0, 0, 0, 0) : null;
            const end = ev?.fechaFin ? new Date(ev.fechaFin).setHours(0, 0, 0, 0) : null;

            if (estado !== "todos") {
                if (estado === "pasados") okEstado = !!end && end < today;
                if (estado === "actuales") okEstado = !!start && !!end && start <= today && today <= end;
                if (estado === "futuros") okEstado = !!start && start > today;
            }

            return matchesText && okDate && okEstado;
        })
        .sort((a, b) => {
            if (sortBy === "inicio") return String(a?.fechaInicio || "").localeCompare(String(b?.fechaInicio || ""));
            if (sortBy === "nombre") return String(a?.nombre || "").localeCompare(String(b?.nombre || ""));
            return 0;
        });

    return out;
};
